import React from 'react';

/**
 * Symbol cell of a leg row. The live price and its age sit on a second line, so the leg
 * tables keep four columns and fit the config panel without scrolling sideways.
 */
export const LegSymbolCell: React.FC<{
    name: React.ReactNode;
    price: string;
    priceMissing?: boolean;
    age?: React.ReactNode;
}> = ({ name, price, priceMissing, age }) => (
    <div style={{ minWidth: 0 }}>
        {name}
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: 4,
                marginTop: 2,
                fontSize: 11,
                fontVariantNumeric: 'tabular-nums',
                color: priceMissing ? '#848E9C' : '#B7BDC6',
            }}
        >
            {price}
            {age}
        </div>
    </div>
);
